import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: string;
  title: string;
  thumbnail: string;
  author: { name: string; avatar: string };
  views: string;
  likes: string;
  duration: string;
  isHot?: boolean;
  isNew?: boolean;
  tags?: string[];
}

export default function VideoCard({ id, title, thumbnail, author, views, likes, duration, isHot, isNew, tags }: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-200 transition-all duration-300"
    >
      <div className="relative aspect-video overflow-hidden bg-background-200">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute bottom-2 right-2 bg-foreground-900/75 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
          {duration}
        </div>
        {(isHot || isNew) && (
          <div className="absolute top-2 left-2 flex gap-1.5">
            {isHot && (
              <span className="bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">热门</span>
            )}
            {isNew && (
              <span className="bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">新上</span>
            )}
          </div>
        )}
      </div>

      <div className="p-3.5">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-2.5 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>

        <div className="flex items-center gap-2 mb-3">
          <img
            src={author.avatar}
            alt={author.name}
            className="w-6 h-6 rounded-full object-cover flex-shrink-0"
            loading="lazy"
          />
          <span className="text-xs text-foreground-500 truncate">{author.name}</span>
        </div>

        {tags && tags.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mb-2.5">
            {tags.slice(0, 3).map((tag) => (
              <span key={tag} className="text-xs text-accent-700 bg-accent-50 px-2 py-0.5 rounded-md">
                {tag}
              </span>
            ))}
          </div>
        )}

        <div className="flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line text-xs"></i>
            {views}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-heart-line text-xs"></i>
            {likes}
          </span>
        </div>
      </div>
    </Link>
  );
}